// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"34":"9198e7b7","425":"4c5b8885","510":"cde8ef73","532":"414d80e7","633":"5f8b0abd","634":"37f8fc3f","922":"7f52ad83","937":"29e7de83","972":"fd918f2c"}[chunkId] + ".chunk.js";
};